// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { useRef } from "react"
import { Navigate } from "react-router-dom"
import { DEFAULT_LANDING, takeReturnTo } from "@/lib/return-to"

// Landing route of the GitHub OAuth round trip. The session already rides
// the cookie the callback set, so this is a plain navigation: it reads
// nothing from the URL and holds no credential.
export default () => {
  // Consumed once per mount: `takeReturnTo` clears the carrier, and a
  // StrictMode double render must not lose the destination.
  const destination = useRef<string | null>(null)
  if (destination.current === null) {
    destination.current = takeReturnTo() ?? DEFAULT_LANDING
  }

  return <Navigate to={destination.current} replace />
}
